<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    top="5vh"
    width="92%"
    append-to-body
    custom-class="api-doc-dialog"
    @close="hide"
  >
    <!-- ✅ 自定义标题：左 Tabs + 右 user/secret（全局） -->
    <div slot="title" class="api-doc__titleBar">
      <div class="api-doc__tabs">
        <el-tabs v-model="activeSport" @tab-click="onSportChange">
          <!-- <el-tab-pane label="总览" name="overview" /> -->
          <el-tab-pane label="足球" name="football" />
          <el-tab-pane label="篮球" name="basketball" />
          <!-- <el-tab-pane label="网球" name="tennis" />
          <el-tab-pane label="LOL" name="lol" />
          <el-tab-pane label="CS:GO" name="csgo" />
          <el-tab-pane label="DOTA2" name="dota2" />
          <el-tab-pane label="KOG" name="kog" />
          <el-tab-pane label="VALORANT" name="valorant" /> -->
        </el-tabs>
      </div>

      <!-- ✅ 全局 user/secret（不在接口详情中） -->
      <div class="api-doc__globalCred mr-5 p4-5">
       

        <div class="api-doc__credItem">
          <span class="api-doc__credLabel">secret</span>
          <span class="api-doc__credValue">{{ credSecretMasked }}</span>
          <el-button size="mini" type="text" @click="toggleSecret">
            {{ showSecret ? '隐藏' : '显示' }}
          </el-button>
          <el-button size="mini" type="text" @click="copyText(credSecret)">复制</el-button>
        </div>
		
		<div class="api-doc__credItem">
		  <span class="api-doc__credLabel">user</span>
		  <span class="api-doc__credValue">{{ credUser || '-' }}</span>
		  <el-button size="mini" type="text" @click="copyText(credUser)">复制</el-button>
		</div>
      </div>
    </div>

    <el-container class="api-doc__container">
      <!-- 左侧 -->
      <el-aside class="api-doc__aside">
        <div class="api-doc__asideHeader">
          <el-input
            v-model="keyword"
            size="small"
            placeholder="搜索接口名称或URL"
            prefix-icon="el-icon-search"
            clearable
          />
        </div>

        <el-menu
          :default-active="activeMenu"
          :unique-opened="false"
          class="api-doc__menu"
          @select="onSelectEndpoint"
        >
          <template v-for="g in filteredMenu">
            <!-- 有 children：老接口，原样 -->
            <el-submenu
              v-if="g.children && g.children.length"
              :key="g.key"
              :index="g.key"
            >
              <template slot="title">
                <span>{{ g.title }}</span>
              </template>
          
              <el-menu-item
                v-for="c in g.children"
                :key="c.key"
                :index="c.key"
              >
                <span class="api-doc__method">{{ c.method }}</span>
                <span class="api-doc__name">{{ c.title }}</span>
              </el-menu-item>
            </el-submenu>
          
            <!-- 没 children：单层菜单（状态码用这个） -->
            <el-menu-item class="mb-5"
              v-else
              :key="g.key"
              :index="g.key"
            >
              <!-- ✅ method 有值才显示（状态码 method='' 就不会占位） -->
              <span v-if="g.method" class="api-doc__method">{{ g.method }}</span>
            
              <!-- ✅ method 为空：去掉左边距，让文字贴左 -->
              <span class="api-doc__name" style="margin-left:0" :class="{ 'api-doc__name--solo': !g.method }">{{g.title}}</span>
            </el-menu-item>

          </template>


          <div v-if="filteredMenu.length === 0" class="api-doc__empty">
            无匹配结果
          </div>
        </el-menu>
      </el-aside>

      <!-- 右侧 -->
      <el-main class="api-doc__main">
        <div class="api-doc__content">
          <div v-if="!currentEndpoint" class="api-doc__placeholder">
            请选择左侧一个接口
          </div>
		  
		  
		  <div v-else>
		    <!-- ========================= -->
		    <!-- ✅ 状态码专用页面 -->
		    <!-- ========================= -->
		    <div v-if="currentEndpoint && currentEndpoint._page === 'status_code'">
		      <!-- <div class="api-doc__header">
		        <div class="api-doc__endpointTitle">状态码</div>
		        <div class="api-doc__desc">
		          {{ activeSport === 'football' ? '足球' : '篮球' }}状态码说明（固定前端数据）
		        </div>
		      </div> -->
		    
		      <div v-for="(sec, idx) in currentStatusSections" :key="idx" class="api-doc__section">

		        <div class="api-doc__sectionTitle">{{ sec.title }}</div>
		        <div class="api-doc__sectionBody">
		          <el-table :data="sec.rows" size="mini" border class="api-doc__table">
		            <el-table-column prop="code" label="状态码" width="90" />
		            <el-table-column prop="desc" label="描述" min-width="360" />
		          </el-table>
		        </div>
		      </div>
		    </div>
		  
		    <!-- ========================= -->
		    <!-- ✅ 原有接口页面（完全不动） -->
		    <!-- ========================= -->
		    <div v-else>
		      <!-- 接口基础信息 -->
		      <div class="api-doc__header">
		        <div class="api-doc__endpointTitle">{{ currentEndpoint.title }}</div>
		    
		        <div class="api-doc__endpointMeta my-3">
		          <span class="api-doc__methodPill">{{ currentEndpoint.method }}</span>
		          <span class="api-doc__path">{{ currentEndpoint.path }}</span>
		        </div>
		    
		        <div v-if="currentEndpoint.desc" class="api-doc__desc">
		          {{ currentEndpoint.desc }}
		        </div>
		      </div>
		    
		      <!-- 请求参数 -->
		      <div class="api-doc__section">
		        <div class="api-doc__sectionTitle">请求参数</div>
		        <div class="api-doc__sectionBody">
		          <el-table
		            v-if="doc && doc.request && doc.request.length"
		            :data="doc.request"
		            size="mini"
		            border
		            class="api-doc__table"
		          >
		            <el-table-column prop="name" label="参数名" min-width="140" />
		            <el-table-column prop="required" label="必填" width="90">
		              <template slot-scope="scope">
		                <span :class="scope.row.required ? 'req-yes' : 'req-no'">
		                  {{ scope.row.required ? '必填' : '可选' }}
		                </span>
		              </template>
		            </el-table-column>
		            <el-table-column prop="type" label="类型" width="140" />
		            <el-table-column prop="desc" label="说明" min-width="240" />
		          </el-table>
		          <div v-else class="api-doc__muted">无</div>
		        </div>
		      </div>
		    
		      <!-- 返回参数 -->
		      <div class="api-doc__section">
		        <div class="api-doc__sectionTitle">返回参数</div>
		    
		        <div class="api-doc__sectionBody">
		          <!-- 200/404 可折叠（头部色条） -->
		          <el-collapse v-model="openRespCodes"  class="api-doc__respCollapse ">
		            <el-collapse-item 
		              v-for="r in (doc && doc.responses ? doc.responses : [])"
		              :key="String(r.code)"
		              :name="String(r.code)"
		    					class="my-2"
		              :class="'resp-item resp-item-' + String(r.code)"
		            >
		              <template slot="title">
		                <div class="resp-bar">
		                  <i
		                    class="resp-icon"
		                    :class="String(r.code) === '200' ? 'el-icon-check' : 'el-icon-close'"
		                  ></i>
		                  <span class="resp-bar__code">{{ r.code }}</span>
		                  <span class="resp-bar__text">{{ r.title || '' }}</span>
		                </div>
		              </template>
		    
		              <div class="resp-body">
		                <div class="resp-ct" v-if="r.contentType">{{ r.contentType }}</div>
		    
		                <!-- ✅ 树形结构（像菜单一样可点击展开/收起） -->
		                <schema-tree-menu
		                  v-if="r.schema && r.schema.length"
		                  :nodes="r.schema"
		                  :expandAll="true"
		                />
		                <div v-else class="api-doc__muted">无返回结构</div>
		    
		                <!-- 示例：纯 JSON 代码块 -->
		               <!-- <div v-if="r.example && r.schema && r.schema.length" class="resp-example">
		                  <div class="resp-example__title">示例</div>
		                  <example-tree-drawer :schema="r.schema" :example="r.example" />
		                </div> -->
		              </div>
		            </el-collapse-item>
		          </el-collapse>
		    
		          <div v-if="!doc || !doc.responses || !doc.responses.length" class="api-doc__muted">
		            无
		          </div>
		        </div>
		      </div>
		    
		    </div>
		  </div>

          
        </div>
      </el-main>
    </el-container>
  </el-dialog>
</template>

<script>
/**
 * ✅ 工具：给 schema 节点补 _id（el-tree node-key 需要）
 */
function addIds(nodes, parentId = '') {
  return (nodes || []).map((n, idx) => {
    const id = (parentId ? parentId + '.' : '') + (n.name || 'field') + '_' + idx
    const out = Object.assign({}, n, { _id: id })
    if (out.children && out.children.length) {
      out.children = addIds(out.children, id)
    }
    return out
  })
}

/**
 * ✅ SchemaTreeMenu（返回结构树）
 * - render(h) 版本：runtime-only 可用
 * - 每行：字段 | 类型 | 说明
 */
const SchemaTreeMenu = {
  name: 'SchemaTreeMenu',
  props: {
    nodes: { type: Array, default: () => [] },
    defaultExpandedNames: { type: Array, default: () => [] } ,// e.g. ['results']
	expandAll: { type: Boolean, default: false } // ✅ 新增
  },
  computed: {
    treeData() {
      return addIds(this.nodes, '')
    },
    defaultExpandedKeys() {
      const keys = []
      const dfs = (arr) => {
        (arr || []).forEach(n => {
          // ✅ expandAll=true：只要有 children 就默认展开
          if (this.expandAll) {
            if (n.children && n.children.length) keys.push(n._id)
          } else {
            // 原来的逻辑：按名字展开
            if (this.defaultExpandedNames.includes(n.name)) keys.push(n._id)
          }
    
          if (n.children && n.children.length) dfs(n.children)
        })
      }
      dfs(this.treeData)
      return keys
    }

  },
  render(h) {
    const header = h('div', { class: 'schema-tree__head schema-tree__head--2col' }, [
      h('div', { class: 'schema-tree__col schema-tree__col--name' }, ['字段']),
      h('div', { class: 'schema-tree__col schema-tree__col--meta' }, ['类型 / 说明'])
    ])

    const tree = h(
      'el-tree',
      {
        class: 'schema-tree__tree',
        props: {
          data: this.treeData,
          'node-key': '_id',
          props: { children: 'children', label: 'name' },
          'default-expanded-keys': this.defaultExpandedKeys,
          'expand-on-click-node': true,
          'highlight-current': false
        },
        scopedSlots: {
          default: ({ node, data }) => {
            // 1) tuple 数组 index：name 是 0/1/2... 且父节点是 array
            const isTupleIndex =
              /^\d+$/.test(String(data.name || '')) &&
              node && node.parent && node.parent.data &&
              node.parent.data.type === 'array'
        
            // 2) 是否是 “包了一层的 Enum Array[1]”
            //    形态：父是 tupleIndex，自己 type=array，且 children 只有一个 name=0
            const isEnumWrapperArray1 =
              isTupleIndex &&
              data.type === 'array' &&
              Array.isArray(data.children) &&
              data.children.length === 1 &&
              String(data.children[0].name) === '0'
        
            // 3) 当前节点是否是“tuple array 节点”（children 全是 0/1/2...）
            const isTupleArrayNode =
              data.type === 'array' &&
              Array.isArray(data.children) &&
              data.children.length > 0 &&
              data.children.every(ch => /^\d+$/.test(String(ch.name || '')))
        
            // 4) 去重：如果父节点 desc 里已经把 0/1/2 的明细写进去了，
            //    那就只保留到 "Enum：Array [n]" 那一行，避免重复显示两份
            const stripEnumDetails = (s) => {
              if (!s) return s
              // desc 里含有 "0：" 或 "1：" 或 "2：" 说明明细被写进去了
              const hasDetail = /^\s*\d+：/m.test(s)
              if (!hasDetail) return s
        
              // 尝试截断到 "Enum：Array [n]" 这一行（含该行）
              const m = s.match(/([\s\S]*?Enum：\s*Array\s*\[\d+\][^\n]*)(\n|$)/)
              return m ? m[1] : s
            }
        
            // ✅ A) wrapper 行：不让它变成一层“树节点”，只显示成一行 Enum 信息
            if (isEnumWrapperArray1) {
              const enumDesc = `${data.name}：${data.desc || ''}` // 0：Enum：Array [1]
              return h('div', { class: 'schema-tree__row schema-tree__row--2col' }, [
                h('div', { class: 'schema-tree__cell schema-tree__cell--name' }, ['']),
                h('div', { class: 'schema-tree__cell schema-tree__cell--meta' }, [
                  h('div', { class: 'schema-tree__metaType' }, ['array']),
                  h('div', { class: 'schema-tree__metaDesc' }, [enumDesc])
                ])
              ])
            }
        
            // ✅ B) 普通 tupleIndex（如 title_holder 的 0/1）：左列隐藏，右列加前缀 “0：/1：”
            const leftName = isTupleIndex ? '' : (data.name || '')
            const rawDescText = isTupleIndex
              ? `${data.name}：${data.desc || ''}`
              : (data.desc || '')
        
            // ✅ C) 去重：父节点是 tuple array 时，desc 只保留到 Enum 行，避免 0/1 再出现一次
            const finalDescText =
              (!isTupleIndex && isTupleArrayNode)
                ? stripEnumDetails(rawDescText)
                : rawDescText
        
            return h('div', { class: 'schema-tree__row schema-tree__row--2col' }, [
              h('div', { class: 'schema-tree__cell schema-tree__cell--name' }, [leftName]),
              h('div', { class: 'schema-tree__cell schema-tree__cell--meta' }, [
                h('div', { class: 'schema-tree__metaType' }, [data.type || '']),
                h('div', { class: 'schema-tree__metaDesc' }, [finalDescText])
              ])
            ])
          }
        }



      },
      []
    )

    return h('div', { class: 'schema-tree' }, [header, tree])
  }
}

/**
 * ✅ ExampleTreeDrawer（示例抽屉树）
 * - 用 schema 结构做树，值来自 example JSON
 * - results 可展开
 * - 每行：字段 | 类型 | 说明 | 示例值
 */
const ExampleTreeDrawer = {
  name: 'ExampleTreeDrawer',
  props: {
    schema: { type: Array, default: () => [] },
    example: { type: [Object, Array], default: () => ({}) }
  },
  computed: {
    treeData() {
      return addIds(this.schema, '')
    },
    defaultExpandedKeys() {
      const keys = []
      const expandNames = ['results', 'query', 'data']
      const dfs = (arr) => {
        (arr || []).forEach(n => {
          if (expandNames.includes(n.name)) keys.push(n._id)
          if (n.children && n.children.length) dfs(n.children)
        })
      }
      dfs(this.treeData)
      return keys
    }
  },
  methods: {
    // 根据路径取示例值：数组默认取第 0 个元素
    getValueByPath(root, pathParts) {
      let cur = root
      for (const p of pathParts) {
        if (cur == null) return undefined
        if (Array.isArray(cur)) cur = cur.length ? cur[0] : undefined
        if (cur && typeof cur === 'object') cur = cur[p]
        else return undefined
      }
      return cur
    },
    formatValue(v) {
      if (v === null) return 'null'
      if (v === undefined) return ''
      if (typeof v === 'string') return `"${v}"`
      if (typeof v === 'number' || typeof v === 'boolean') return String(v)
      if (Array.isArray(v)) return `Array(${v.length})`
      if (typeof v === 'object') return 'Object'
      return String(v)
    },
    // 从 el-tree 的 node.path 提取字段路径
    nodePathToFieldNames(node) {
      return (node.path || [])
        .map(x => (x && x.data ? x.data.name : ''))
        .filter(Boolean)
    }
  },
  render(h) {
    const header = h('div', { class: 'example-tree__head' }, [
      h('div', { class: 'example-tree__col example-tree__col--name' }, ['字段']),
      h('div', { class: 'example-tree__col example-tree__col--type' }, ['类型']),
      h('div', { class: 'example-tree__col example-tree__col--desc' }, ['说明']),
      h('div', { class: 'example-tree__col example-tree__col--val' }, ['示例值'])
    ])

    const tree = h(
      'el-tree',
      {
        class: 'example-tree__tree',
        props: {
          data: this.treeData,
          'node-key': '_id',
          props: { children: 'children', label: 'name' },
          'default-expanded-keys': this.defaultExpandedKeys,
          'expand-on-click-node': true,
          'highlight-current': false
        },
        scopedSlots: {
          default: ({ node, data }) => {
            const path = this.nodePathToFieldNames(node)
            const val = this.getValueByPath(this.example, path)

            return h('span', { class: 'example-tree__row' }, [
              h('span', { class: 'example-tree__cell example-tree__cell--name' }, [data.name || '']),
              h('span', { class: 'example-tree__cell example-tree__cell--type' }, [data.type || '']),
              h('span', { class: 'example-tree__cell example-tree__cell--desc' }, [data.desc || '']),
              h('span', { class: 'example-tree__cell example-tree__cell--val' }, [this.formatValue(val)])
            ])
          }
        }
      },
      []
    )

    return h('div', { class: 'example-tree' }, [header, tree])
  }
}

export default {
  components: { SchemaTreeMenu, ExampleTreeDrawer },

  props: {
    matchApiModel: { type: Boolean, default: false },
    isphone: { type: Boolean, default: false }
  },

  data() {
    return {
      visible: false,
      activeSport: 'football',
      keyword: '',
      activeMenu: '',
      openRespCodes: ['200'],

      // 全局 user/secret（你顶部 title 右侧用）
      credUser: '',
      credSecret: '',
      showSecret: false,

      allMenuData: {
        football: [],
        basketball: [],
        overview: [],
        tennis: [],
        lol: [],
        csgo: [],
        dota2: [],
        kog: [],
        valorant: []
      },
	  footballStatusSections: [
	    {
	      title: '比赛状态',
	      rows: [
	        { code: 0, desc: '比赛异常，说明：暂未判断具体原因的异常比赛，可能但不限于：腰斩、取消等等，建议隐藏处理' },
	        { code: 1, desc: '未开赛' },
	        { code: 2, desc: '上半场' },
	        { code: 3, desc: '中场' },
	        { code: 4, desc: '下半场' },
	        { code: 5, desc: '加时赛' },
	        { code: 6, desc: '加时赛(弃用)' },
	        { code: 7, desc: '点球决战' },
	        { code: 8, desc: '完场' },
	        { code: 9, desc: '推迟' },
	        { code: 10, desc: '中断' },
	        { code: 11, desc: '腰斩' },
	        { code: 12, desc: '取消' },
	        { code: 13, desc: '待定' }
	      ]
	    },
	    {
	      title: '技术统计',
	      rows: [
	        { code: 1, desc: '进球' },
	        { code: 2, desc: '角球' },
	        { code: 3, desc: '黄牌' },
	        { code: 4, desc: '红牌' },
	        { code: 5, desc: '越位' },
	        { code: 6, desc: '任意球' },
	        { code: 7, desc: '球门球' },
	        { code: 8, desc: '点球' },
	        { code: 9, desc: '换人' },
	        { code: 10, desc: '比赛开始' },
	        { code: 11, desc: '中场' },
	        { code: 12, desc: '结束' },
	        { code: 13, desc: '半场比分' },
	        { code: 15, desc: '两黄变红' },
	        { code: 16, desc: '点球未进' },
	        { code: 17, desc: '乌龙球' },
	        { code: 18, desc: '助攻' },
	        { code: 19, desc: '伤停补时' },
	        { code: 21, desc: '射正' },
	        { code: 22, desc: '射偏' },
	        { code: 23, desc: '进攻' },
	        { code: 24, desc: '危险进攻' },
	        { code: 25, desc: '控球率' },
	        { code: 26, desc: '加时赛结束' },
	        { code: 27, desc: '点球大战结束' },
	        { code: 28, desc: 'VAR(视频助理裁判)' },
	        { code: 29, desc: '点球(点球大战)' },
	        { code: 30, desc: '点球未进(点球大战)' },
	        { code: 37, desc: '射门被阻挡' }
	      ]
	    },
	    {
	      title: '指数公司ID',
	      rows: [
	        { code: 2, desc: 'BET365' },
	        { code: 3, desc: '皇冠' },
	        { code: 4, desc: '10BET' },
	        { code: 5, desc: '立博' },
	        { code: 6, desc: '明陞' },
	        { code: 7, desc: '澳彩' },
	        { code: 8, desc: 'SNAI' },
	        { code: 9, desc: '威廉希尔' },
	        { code: 10, desc: '易胜博' },
	        { code: 11, desc: '韦德' },
	        { code: 12, desc: 'EuroBet' },
	        { code: 13, desc: 'Inter wetten' },
	        { code: 14, desc: '12bet' },
	        { code: 15, desc: '利记' },
	        { code: 16, desc: '盈禾' },
	        { code: 17, desc: '18Bet' },
	        { code: 18, desc: 'Fun88' },
	        { code: 19, desc: '竞彩官方' },
	        { code: 20, desc: 'onex' },
	        { code: 21, desc: '188' },
	        { code: 22, desc: '平博' },
	        { code: 136, desc: '马会' }
	      ]
	    },
	    {
	      title: '事件原因',
	      rows: [
	        { code: 1, desc: '犯规' },
	        { code: 2, desc: '个人犯规' },
	        { code: 3, desc: '侵犯对手(罚牌事件)/受伤换人(换人事件)' },
	        { code: 4, desc: '战术犯规(罚牌事件)/战术换人(换人事件)' },
	        { code: 5, desc: '进攻犯规' },
	        { code: 6, desc: '无球犯规' },
	        { code: 7, desc: '持续犯规' },
	        { code: 8, desc: '持续侵犯' },
	        { code: 9, desc: '暴力行为' },
	        { code: 10, desc: '危险动作' },
	        { code: 11, desc: '手球犯规' },
	        { code: 12, desc: '严重犯规' },
	        { code: 13, desc: '故意犯规（防守球员为最后一名防守人时）' },
	        { code: 14, desc: '阻挡进球机会' },
	        { code: 15, desc: '拖延时间' },
	        { code: 16, desc: '视频回看裁定' },
	        { code: 17, desc: '判罚取消' },
	        { code: 18, desc: '争论' },
	        { code: 19, desc: '对判罚表达异议' },
	        { code: 20, desc: '犯规和攻击言语' },
	        { code: 21, desc: '过度庆祝' },
	        { code: 22, desc: '没有回退到要求的距离' },
	        { code: 23, desc: '打架' },
	        { code: 24, desc: '辅助判罚' },
	        { code: 25, desc: '替补席' },
	        { code: 26, desc: '赛后行为' },
	        { code: 27, desc: '其他原因' },
	        { code: 28, desc: '未被允许进入场地' },
	        { code: 29, desc: '进入比赛场地' },
	        { code: 30, desc: '离开比赛赛场' },
	        { code: 31, desc: '非体育道德行为' },
	        { code: 32, desc: '非主观意愿的恶意犯规' },
	        { code: 33, desc: '假摔' },
	        { code: 34, desc: '干预var复审' },
	        { code: 35, desc: '进入裁判评审区' },
	        { code: 36, desc: '吐口水（向球员或裁判）' },
	        { code: 37, desc: '病毒' },
	        { code: 0, desc: '未知' }
	      ]
	    },
	    {
	      title: '数据更新类型ID',
	      rows: [
	        { code: 2, desc: '单场阵容' },
	        { code: 3, desc: '集锦录像' },
	        { code: 5, desc: '对阵图' },
	        { code: 6, desc: '积分榜' },
	        { code: 7, desc: '赛季球队球员统计' },
	        { code: 8, desc: 'fifa men排名' },
	        { code: 9, desc: 'fifa women排名' },
	        { code: 10, desc: '俱乐部排名' },
	        { code: 12, desc: '事件动图' }
	      ]
	    },
	    {
	      title: '半全场统计ID',
	      rows: [
	        { code: 1, desc: '进球' },
	        { code: 2, desc: '角球' },
	        { code: 3, desc: '黄牌' },
	        { code: 4, desc: '红牌' },
	        { code: 5, desc: '越位' },
	        { code: 6, desc: '任意球' },
	        { code: 7, desc: '球门球' },
	        { code: 8, desc: '点球' },
	        { code: 9, desc: '换人' },
	        { code: 15, desc: '两黄变红' },
	        { code: 16, desc: '点球未进' },
	        { code: 17, desc: '乌龙球' },
	        { code: 21, desc: '射正' },
	        { code: 22, desc: '射偏' },
	        { code: 23, desc: '进攻' },
	        { code: 24, desc: '危险进攻' },
	        { code: 25, desc: '控球率' },
	        { code: 32, desc: '界外球' },
	        { code: 33, desc: '过人' },
	        { code: 34, desc: '过人成功' },
	        { code: 36, desc: '解围' },
	        { code: 37, desc: '射门被阻挡' },
	        { code: 38, desc: '拦截' },
	        { code: 39, desc: '抢断' },
	        { code: 40, desc: '传球' },
	        { code: 41, desc: '传球成功' },
	        { code: 42, desc: '关键传球' },
	        { code: 43, desc: '传中球' },
	        { code: 44, desc: '传中球成功' },
	        { code: 45, desc: '长传' },
	        { code: 46, desc: '成功长传' },
	        { code: 48, desc: '1对1拼抢成功' },
	        { code: 49, desc: '丢球' },
	        { code: 51, desc: '犯规' },
	        { code: 52, desc: '扑救' },
	        { code: 53, desc: '拳击球' },
	        { code: 54, desc: '守门员出击' },
	        { code: 55, desc: '守门员出击成功' },
	        { code: 56, desc: '高空出击' },
	        { code: 61, desc: '1对1拼抢失败' },
	        { code: 63, desc: '获得任意球' },
	        { code: 65, desc: '任意球得分' },
	        { code: 69, desc: '击中门框' },
	        { code: 70, desc: '快攻' },
	        { code: 71, desc: '快攻射门' },
	        { code: 72, desc: '快攻进球' },
	        { code: 78, desc: '丢失球权' },
	        { code: 79, desc: '空中对抗胜利' },
	        { code: 80, desc: '空中对抗失败' },
	        { code: 81, desc: '地面对抗胜利' },
	        { code: 82, desc: '地面对抗失败' },
	        { code: 83, desc: '射门' }
	      ]
	    }
	  ],
	  basketballStatusSections: [
	    {
	      title: '比赛状态',
	      rows: [
	        { code: 0, desc: '比赛异常，说明：暂未判断具体原因的异常比赛，可能但不限于：腰斩、取消等等，建议隐藏处理' },
	        { code: 1, desc: '未开赛' },
	        { code: 2, desc: '第一节' },
	        { code: 3, desc: '第一节完' },
	        { code: 4, desc: '第二节' },
	        { code: 5, desc: '第二节完' },
	        { code: 6, desc: '第三节' },
	        { code: 7, desc: '第三节完' },
	        { code: 8, desc: '第四节' },
	        { code: 9, desc: '加时' },
	        { code: 10, desc: '完场' },
	        { code: 11, desc: '中断' },
	        { code: 12, desc: '取消' },
	        { code: 13, desc: '延期' },
	        { code: 14, desc: '腰斩' },
	        { code: 15, desc: '待定' }
	      ]
	    },
	    {
	      title: '技术统计',
	      rows: [
	        { code: 1, desc: '3分球进球数' },
	        { code: 2, desc: '2分球进球数' },
	        { code: 3, desc: '罚球进球数' },
	        { code: 4, desc: '小节剩余暂停数' },
	        { code: 5, desc: '小节犯规数' },
	        { code: 6, desc: '罚球命中率' },
	        { code: 7, desc: '总暂停数' }
	      ]
	    },
	    {
	      title: '指数公司ID',
	      rows: [
	        { code: 2, desc: 'BET365' },
	        { code: 3, desc: '皇冠' },
	        { code: 4, desc: '10BET' },
	        { code: 5, desc: '立博' },
	        { code: 6, desc: '明陞' },
	        { code: 7, desc: '澳彩' },
	        { code: 8, desc: 'SNAI' },
	        { code: 9, desc: '威廉希尔' },
	        { code: 10, desc: '易胜博' },
	        { code: 11, desc: '韦德' },
	        { code: 12, desc: 'EuroBet' },
	        { code: 13, desc: 'Inter wetten' },
	        { code: 14, desc: '12bet' },
	        { code: 15, desc: '利记' },
	        { code: 16, desc: '盈禾' },
	        { code: 17, desc: '18Bet' },
	        { code: 18, desc: 'Fun88' },
	        { code: 19, desc: '竞彩官方' },
	        { code: 20, desc: 'onex' },
	        { code: 21, desc: '188' },
	        { code: 22, desc: '平博' }
	      ]
	    },
	    {
	      title: '数据更新类型ID',
	      rows: [
	        { code: 3, desc: '集锦录像' },
	        { code: 5, desc: '对阵图' },
	        { code: 6, desc: '积分榜' },
	        { code: 7, desc: '赛季球队球员统计' },
	        { code: 8, desc: 'fiba men排名' },
	        { code: 9, desc: 'fiba women排名' }
	      ]
	    }
	  ],

	  }

	},

  computed: {
	  currentStatusSections() {
	    return this.activeSport === 'basketball'
	      ? (this.basketballStatusSections || [])
	      : (this.footballStatusSections || [])
	  },
    currentMenuList() {
      return this.allMenuData[this.activeSport] || []
    },

    filteredMenu() {
      const list = this.currentMenuList
      const kw = (this.keyword || '').trim().toLowerCase()
      if (!kw) return list

      return list
        .map(g => {
          const children = (g.children || []).filter(c => {
            const t = (c.title || '').toLowerCase()
            const p = (c.path || '').toLowerCase()
            const d = (c.desc || '').toLowerCase()
            return t.includes(kw) || p.includes(kw) || d.includes(kw)
          })
          return { ...g, children }
        })
        .filter(g => g.children && g.children.length > 0)
    },

    currentEndpoint() {
      if (!this.activeMenu) return null
    
      for (const g of this.currentMenuList) {
        // ✅ 单层菜单（状态码）
        if ((!g.children || !g.children.length) && g.key === this.activeMenu) {
          return g
        }
    
        // ✅ 原来的接口
        const hit = (g.children || []).find(x => x.key === this.activeMenu)
        if (hit) return hit
      }
      return null
    },


    doc() {
      const d = this.currentEndpoint && this.currentEndpoint.doc
        ? this.currentEndpoint.doc
        : null
      if (!d) return null
    
      const GLOBAL_404 = {
        code: 404,
        title: '资源不存在',
        contentType: 'application/json',
        schema: [
          { name: 'code', type: 'integer', desc: '状态码' },
          { name: 'msg', type: 'string', desc: '错误信息' }
        ],
        example: { code: 404, msg: '资源不存在' }
      }
    
      const rs = Array.isArray(d.responses) ? d.responses.slice() : []
      const has404 = rs.some(x => String(x.code) === '404')
      if (!has404) rs.push(GLOBAL_404)
    
      return { ...d, responses: rs }
    },

    credSecretMasked() {
      if (!this.credSecret) return '-'
      if (this.showSecret) return this.credSecret
      const s = this.credSecret
      if (s.length <= 6) return '******'
      return s.slice(0, 3) + '******' + s.slice(-3)
    }
  },

  watch: {
    matchApiModel: {
      immediate: true,
      handler(v) {
        this.visible = v
        if (v) {
		  this.getData()
          this.loadCredFromSession()
          this.ensureDefaultSelection()
          this.resetCollapseDefault()
        }
      }
    },
    visible(v) {
      this.$emit('update:matchApiModel', v)
    },
    activeSport() {
      this.keyword = ''
      this.activeMenu = ''
      this.ensureDefaultSelection()
    },
    filteredMenu() {
      this.ensureSelectionVisible()
    },
    currentEndpoint() {
      this.resetCollapseDefault()
    }
  },

  methods: {
	  
	getData() {
	  this.load = true
	  this.axios.post('/admin/data/getApiDocData', {}, { token: true })
	    .then(res => {
	      const all = res.data
		  console.log(all)
	      if (all && all.code == 1 && all.data) {
	        // ✅ 直接替换数据源
	        this.allMenuData = {
	          football: [],
	          basketball: [],
	          overview: [],
	          tennis: [],
	          lol: [],
	          csgo: [],
	          dota2: [],
	          kog: [],
	          valorant: [],
	          ...all.data.list
	        }
			 
			// ===============================
			// ✅ 前端固定注入：状态码（不走后端）
			// ===============================
			const makeStatusMenu = (sport) => ({
			  key: `${sport}_status_code`,
			  title: '状态码',
			  method: '',           // ✅ 为空：保证文字贴左（你模板里已处理）
			  path: '/status_code',
			  desc: '比赛状态 / 技术统计 / 指数公司 / 事件原因 等',
			  _page: 'status_code'
			})
			
			const injectOnce = (list, sport) => {
			  const key = `${sport}_status_code`
			  if ((list || []).some(x => x.key === key)) return list
			  // ✅ 放在最底下
			  return [...(list || []), makeStatusMenu(sport)]
			}
			
			// 足球 / 篮球各一个
			this.allMenuData.football = injectOnce(this.allMenuData.football, 'football')
			this.allMenuData.basketball = injectOnce(this.allMenuData.basketball, 'basketball')

			
			
			
	        
	        // ✅ 强制切到 football，并选中第一个接口
	        this.activeSport = 'football'
	        this.$nextTick(() => {
	          this.ensureDefaultSelection()
	        })

	      }
		  
		
	      this.load = false
	
	      // ✅ 数据回来后，重新选中默认接口
	      this.ensureDefaultSelection()
	      this.resetCollapseDefault()
	    })
	    .catch(() => {
	      this.load = false
	    })
	},

    hide() {
		this.$emit('hide')
      this.visible = false
    },
    onSportChange() {},
    onSelectEndpoint(key) {
      this.activeMenu = key
    },

    ensureDefaultSelection() {
      const list = this.currentMenuList
      const firstGroup = (list || []).find(g => g.children && g.children.length)
      if (firstGroup && firstGroup.children[0]) {
        this.activeMenu = firstGroup.children[0].key
      }
    },

    ensureSelectionVisible() {
      if (!this.activeMenu) {
        const g = this.filteredMenu[0]
        if (g && g.children && g.children[0]) this.activeMenu = g.children[0].key
        return
      }
      let exists = false
      for (const g of this.filteredMenu) {
        if ((g.children || []).some(c => c.key === this.activeMenu)) {
          exists = true
          break
        }
      }
      if (!exists) {
        const g = this.filteredMenu[0]
        if (g && g.children && g.children[0]) this.activeMenu = g.children[0].key
        else this.activeMenu = ''
      }
    },

    resetCollapseDefault() {
      const rs = this.doc && this.doc.responses ? this.doc.responses : []
      if (!rs.length) {
        this.openRespCodes = []
        return
      }
      const has200 = rs.some(x => String(x.code) === '200')
      this.openRespCodes = has200 ? ['200'] : [String(rs[0].code)]
    },

    loadCredFromSession() {
      try {
        const u = JSON.parse(window.sessionStorage.getItem('user') || '{}')
        this.credUser =  ''
        this.credSecret = u.secret || ''
      } catch (e) {
        this.credUser = ''
        this.credSecret = ''
      }
    },

    toggleSecret() {
      this.showSecret = !this.showSecret
    },

    async copyText(text) {
      if (!text) {
        this.$message && this.$message.warning('无可复制内容')
        return
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text)
        } else {
          const ta = document.createElement('textarea')
          ta.value = text
          ta.setAttribute('readonly', '')
          ta.style.position = 'fixed'
          ta.style.left = '-9999px'
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }
        this.$message && this.$message.success('已复制')
      } catch (e) {
        this.$message && this.$message.error('复制失败')
      }
    }
  }
}
</script>

<style>

/* ===== Dialog ===== */
.api-doc-dialog .el-dialog__body { padding: 0; }

/* ===== title bar layout ===== */
.api-doc__titleBar{
  display:flex;
  align-items:center;
  gap:12px;
}
.api-doc__tabs{ flex:1; min-width:0; }
.api-doc__tabs .el-tabs__header{ margin:0; }

/* ===== global cred on the right ===== */
.api-doc__globalCred{
  display:flex;
  align-items:center;
  gap:14px;
  flex-wrap:wrap;
}
.api-doc__credItem{
  display:flex;
  align-items:center;
  gap:8px;
  font-size:12px;
}
.api-doc__credLabel{ font-weight:700; opacity:.8; }
.api-doc__credValue{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace;
  background:#fafafa;
  border:1px solid #f0f0f0;
  padding:2px 8px;
  border-radius:4px;
  max-width:260px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

/* ===== container ===== */
.api-doc__container { height: 84vh; border-top: 1px solid #f0f0f0; }

/* ===== left ===== */
.api-doc__aside{
  width:320px!important;
  border-right:1px solid #f0f0f0;
  display:flex;
  flex-direction:column;
  overflow:hidden;
}
.api-doc__asideHeader{ padding:10px 10px 8px; border-bottom:1px solid #f5f5f5; }
.api-doc__menu{ flex:1; overflow:auto; border-right:0; }
.api-doc__empty{ padding:14px; font-size:12px; opacity:.6; }
.api-doc__method{ display:inline-block; width:46px; font-size:12px; opacity:.75; }
.api-doc__name{ margin-left:6px; }

/* ===== right ===== */
.api-doc__main{ padding:0; overflow:hidden; }
.api-doc__content{ height:100%; overflow:auto; padding:14px; }
.api-doc__placeholder{ opacity:.6; padding:20px; }

/* ===== header ===== */
.api-doc__header{
  padding:10px 12px;
  border:1px solid #f0f0f0;
  border-radius:6px;
  margin-bottom:12px;
}
.api-doc__endpointTitle{ font-weight:700; font-size:16px; margin-bottom:8px; }
.api-doc__endpointMeta{ 
	display:flex; align-items:center; gap:10px; margin-bottom:6px; 
	background: #f2f3f5;
	width: fit-content;
	border-radius: 5px;
}
.api-doc__methodPill{ padding:2px 10px; border-radius:4px; background:#FF9561; font-size:12px; font-weight:700;color: #fff; }
.api-doc__path{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace;
  font-size:12px; opacity:.85; word-break:break-all;
  padding-right: 10px;
}
.api-doc__desc{ font-size:12px; opacity:.75; white-space: pre-line;line-height: 30px;}

/* ===== section ===== */
.api-doc__section{ border:1px solid #f0f0f0; border-radius:6px; margin-bottom:12px; }
.api-doc__sectionTitle{ padding:10px 12px; font-weight:600; border-bottom:1px solid #f5f5f5; }
.api-doc__sectionBody{ padding:12px; font-size:12px; }
.api-doc__table{ width:100%; }
.api-doc__muted{ opacity:.65; padding:4px 0; }
.req-yes{ color:#f56c6c; font-weight:600; }
.req-no{ opacity:.65; }

/* ===== response collapse bar like screenshot ===== */
.api-doc__respCollapse .el-collapse-item__header{ height:44px; line-height:44px; border-bottom:0; padding:0; }
.api-doc__respCollapse .el-collapse-item__wrap{ border-bottom:0; }
.resp-item .resp-bar{
  width:100%;
  display:flex;
  align-items:center;
  gap:10px;
  padding:0 12px;
  border-radius:4px;
}
.resp-icon{ font-size:14px; }
.resp-bar__code{ font-weight:800; min-width:36px; }
.resp-bar__text{ font-weight:600; }
.resp-item-200 .resp-bar{ background:#eaf7ee; color:#2e7d32; }
.resp-item-404 .resp-bar{ background:#fdecec; color:#c62828; }
.resp-body{ padding-top:8px; }
.resp-ct{ font-size:12px; opacity:.75; margin-bottom:8px; }

/* ===== Example (code) ===== */
.resp-example{ margin-top:10px; border:1px solid #f0f0f0; border-radius:6px; overflow:hidden; }
.resp-example__title{ padding:8px 10px; border-bottom:1px solid #f5f5f5; font-weight:600; }
.resp-example__pre{
  margin:0; padding:10px; background:#fafafa;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace;
  font-size:12px; line-height:1.5; overflow:auto;
}

/* ================================
   ✅ schema tree（最终稳定对齐版）
   规则：整行 top 对齐；箭头 top 对齐；
        右列 desc 支持换行
   ================================ */

.schema-tree{
  border:1px solid #f0f0f0;
  border-radius:6px;
  overflow:hidden;
  background:#fff;
}

.schema-tree__head{
  display:flex;
  gap:10px;
  padding:8px 10px;
  background:#fafafa;
  border-bottom:1px solid #f0f0f0;
  font-weight:600;
}
.schema-tree__col--name{ flex: 0 0 48%; }
.schema-tree__col--meta{ flex: 1; }

.schema-tree__tree{ padding:8px 6px; }

/* ✅ 关键：让节点行高度自适应，并且整行 top 对齐 */
/* 让 el-tree 每行高度自适应，并顶对齐 */
.schema-tree__tree .el-tree-node__content{
  height:auto !important;
  line-height:normal !important;
  display:flex;
  align-items:flex-start !important;
  padding:8px 0;
}

/* ✅ 箭头固定在第一行位置 */
.schema-tree__tree .el-tree-node__expand-icon{
  align-self:flex-start !important;
  margin-top:2px !important;   /* 你可以 1~4px 微调 */
}

/* 你的两列 */
.schema-tree__row{
  display:flex;
  gap:10px;
  align-items:flex-start;
  width:100%;
}

/* 左列 */
.schema-tree__cell--name{
  flex:0 0 48%;
  line-height:18px;
}

/* 右列：type + desc */
.schema-tree__cell--meta{
  flex:1;
  display:flex;
  flex-direction:column;
  gap:4px;
}

.schema-tree__metaType{
  line-height:18px;
}

.schema-tree__metaDesc{
  line-height:18px;
  white-space:pre-line;
}


/* ✅ 强制箭头盒子不要 26px 高，跟第一行对齐 */
.schema-tree__tree .el-tree-node__expand-icon{
  height:18px !important;
  line-height:18px !important;
  display:flex !important;
  align-items:flex-start !important; /* 图标在盒子里也顶对齐 */
  justify-content:center !important;
  margin-top:0 !important;           /* 先清掉所有偏移 */
  padding-top:2px !important;        /* 你要微调就调这里：1~3px */
}

/* ✅ 有些版本箭头图标本体还会有 line-height，继续压平 */
.schema-tree__tree .el-tree-node__expand-icon i{
  line-height:18px !important;
}

/* ✅ 可选：让整行第一行的“字段名”也固定成同样的行高，视觉更稳 */
.schema-tree__cell--name,
.schema-tree__metaType{
  line-height:18px;
}
.el-submenu .el-menu-item .api-doc__method {
  background: #fff3e6;      /* 浅橙底 */
  color: #ff7a45;           /* 橙色文字 */
  border-radius: 4px;
  text-align: center;
  font-weight: 600;
  line-height: 18px;
}

/* hover 时稍微加深一点 */
.el-submenu .el-menu-item:hover .api-doc__method {
  background: #ffe7cf;
  color: #ff6a00;
}

</style>
